import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import map from 'lodash/map';

import companyPhoneNumbersResource from 'src/actions/companyPhoneNumber/companyPhoneNumbersResource';
import { useResourceValues, someFailed } from 'src/presentation/hooks/useResource';
import { PhoneNumberCapability, PhoneNumberStatus } from 'src/models/CompanyPhoneNumber/CompanyPhoneNumber';
import { toastError } from 'src/actions/toast';
import useConfigurationResource from './useConfigurationResourceByType';

const hasCapability = (capabilitiesList: PhoneNumberCapability[], type) => {
  if (type === PhoneNumberCapability.SMS) {
    return capabilitiesList.some(typeItem => [PhoneNumberCapability.MMS, PhoneNumberCapability.SMS].includes(typeItem));
  }
  return capabilitiesList.includes(type);
};

const isActive = (status: PhoneNumberStatus) => status !== PhoneNumberStatus.DELETED;

export const useAvailableNumbers = (typeAttr = PhoneNumberCapability.VOICE) => {
  const dispatch = useDispatch();

  const { values: configurations } = useConfigurationResource(typeAttr);
  const { values: phoneNumbers, loadingState: phoneNumbersLoadingState } =
    useResourceValues(companyPhoneNumbersResource);
  const loadingError = someFailed(phoneNumbersLoadingState);

  useEffect(() => {
    if (loadingError) {
      dispatch(toastError('Error while loading data. Please wait and try refreshing the page'));
      return;
    }
  }, [loadingError, dispatch]);

  const listOfNumbers = map(configurations, config => config.number);
  const availableNumbers = phoneNumbers.filter(
    ({ phoneNumber, capabilities, status }) =>
      !listOfNumbers.includes(phoneNumber) && hasCapability(capabilities, typeAttr) && isActive(status)
  );
  return { availableNumbers };
};
